module.exports = __webpack_public_path__ + "static/media/mobile_notif_2_car.c91c7bda.png";